import { CiPlay1 } from "react-icons/ci";
import Dropdown from "../../input/Dropdown";
import React, { useEffect, useRef, useState } from "react";
import Grid from "../../Grid";
import Button from "../../input/Button";
import {
  AsyncDropdownValueRenderer,
  AsyncOtherRefDropdownValueRenderer,
  ResizableScrollingTextRenderer,
} from "../../renderer/StyleRenderer";
import { getDropdownData } from "../../../api/keyvalue";
import LoadingSpinner from "../../LoadingSpinner";
import JobMonitorFlag from "../../transaction/JobMonitor/JobMonitorFlag";
import Modal from "../../Modal";
import TimeUpdate from "../../transaction/JobMonitor/TimeUpdate/TimeUpdate";
import { getNullSafeLabel } from "../../../helper";
import { toast } from "react-toastify";
import {
  getActionByJob,
  saveMissionControlAction,
} from "../../../api/missioncontrolApi";
import { useSelector } from "react-redux";
import CallLog from "../CallLog";
import { TextArea } from "semantic-ui-react";
import { formatFromJsonDate } from "../../../dateConfig";
import { statusIdsByContexts } from "../../../api/statusApi";
import { STATUS_GROUPS } from "../../../const";

const MoreInfoOperation = ({ jobInfo }) => {
  const [actionList, setActionList] = useState([]);
  const [actionOptions, setActionOptions] = useState([]);
  const [isLoading, setIsFetchLoading] = useState(false);
  const [isFetchLoading, setIsLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [popUpKey, setPopUpKey] = useState(1);
  const [dataLoadNeeded, setDataLoadNeeded] = useState(true);
  const [tueList, setTueList] = useState([]);
  const modalRef = useRef();

  const user = useSelector((state) => state.user);

  const [action, setAction] = useState({
    mcaAction: 1,
    mcaJob: null,
    mcaJobCode: null,
    mcaRemark: "",
  });

  const closePopup = () => {
    modalRef.current.close();
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const actions = await getDropdownData("mission_control_action");
      const { [STATUS_GROUPS.TIME_UPDATE_ENABLED]: mappedTUEList = [] } =
        await statusIdsByContexts([STATUS_GROUPS.TIME_UPDATE_ENABLED]);
      setTueList(mappedTUEList);
      setActionOptions(actions);
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (jobInfo && dataLoadNeeded) {
        setIsFetchLoading(true);
        const actionsByJob = await getActionByJob(jobInfo.jobId);
        setActionList(actionsByJob);
        setDataLoadNeeded(false);
        setIsFetchLoading(false);
      }
    })();
  }, [jobInfo, dataLoadNeeded]);

  useEffect(() => {
    setAction((prevState) => ({
      ...prevState,
      mcaJob: jobInfo?.jobId,
      mcaJobCode: jobInfo?.jobCode,
    }));
  }, [jobInfo]);

  useEffect(() => {
    if (submitted) {
      setAction({
        mcaAction: 1,
        mcaJob: jobInfo?.jobId,
        mcaJobCode: jobInfo?.jobCode,
        mcaRemark: "",
      });
      setSubmitted(false);
    }
  }, [jobInfo?.jobCode, jobInfo?.jobId, submitted]);

  let modalContentRef = useRef(<></>);

  console.log(jobInfo);

  useEffect(() => {
    if (jobInfo) {
      switch (currentAction) {
        case 1: {
          const timeUpdateViewMode = !tueList.includes(jobInfo.statusId);

          const jobInformation = {
            jobCode: getNullSafeLabel(jobInfo, "jobCode"),
            reqCode: getNullSafeLabel(jobInfo, "reqCode"),
            customer: getNullSafeLabel(jobInfo, "customerName"),
            invoicingCustomer: getNullSafeLabel(jobInfo, "invoicingCustomer"),
            plant: getNullSafeLabel(jobInfo, "shipperName"),
            vehicleType: getNullSafeLabel(jobInfo, "vhtType"),
            driver: getNullSafeLabel(jobInfo, "driverName"),
            helper: getNullSafeLabel(jobInfo, "helperName"),
            vehicle: getNullSafeLabel(jobInfo, "vehVehicleno"),
            transporter: getNullSafeLabel(jobInfo, "transporterName"),
            cbm: getNullSafeLabel(jobInfo, "requestCbm"),
            statusId: jobInfo.statusId,
            status: getNullSafeLabel(jobInfo, "statusName"),
            statusColor: jobInfo.statusColor,
            bookingRequiredDate: jobInfo.bookingRequiredDate
              ? formatFromJsonDate(jobInfo.bookingRequiredDate)
              : "N/A",
            approvedDate: jobInfo.createdDate
              ? formatFromJsonDate(jobInfo.approvedDate)
              : "N/A",
            createdDate: jobInfo.createdDate
              ? formatFromJsonDate(jobInfo.createdDate)
              : "N/A",
            createdBy: jobInfo.createdBy,
          };
          modalContentRef.current = (
            <TimeUpdate
              timeUpdateViewMode={timeUpdateViewMode}
              jobId={jobInfo.jobId}
              jobInfo={jobInformation}
              jobStatus={getNullSafeLabel(jobInfo, "statusName")}
              jobStatusColor={jobInfo.statusColor}
              jobCode={jobInfo.jobCode}
              requestId={jobInfo.jobRequest}
              requestCode={jobInfo.reqCode}
              customerId={jobInfo.customerId}
              bookingRequiredDate={jobInfo.bookingRequiredDate}
            />
          );
          break;
        }
        case 2: {
          modalContentRef.current = (
            <JobMonitorFlag
              key={popUpKey}
              jobId={jobInfo.jobId}
              jobCode={jobInfo.jobCode}
              requestCode={jobInfo.reqCode}
              requestId={jobInfo.jobRequest}
              close={closePopup}
              type={"2"}
              errors={{}}
            />
          );
          break;
        }
        case 3: {
          modalContentRef.current = (
            <JobMonitorFlag
              key={popUpKey}
              jobId={jobInfo.jobId}
              jobCode={jobInfo.jobCode}
              requestCode={jobInfo.reqCode}
              requestId={jobInfo.jobRequest}
              close={closePopup}
              type={"1"}
              errors={{}}
            />
          );
          break;
        }
        case 4: {
          modalContentRef.current = (
            <CallLog key={popUpKey} jobId={jobInfo.jobId} />
          );
          break;
        }
        default:
      }
    }
  }, [jobInfo, currentAction, popUpKey]);

  const submitHandler = async (e) => {
    e.preventDefault();
    setIsSubmitLoading(true);
    if (action.mcaAction === null || action.mcaAction === "") {
      setMcActionErrors((prevState) => ({
        ...prevState,
        mcaAction: "Cannot proceed without an action",
      }));
      return;
    }
    try {
      await saveMissionControlAction({
        mcaAction: action.mcaAction,
        mcaJob: action.mcaJob,
        mcaRemark: action.mcaRemark,
        mcaStatus: 2,
        mcaActive: 1,
        author: user.username,
      });
    } catch (e) {
      console.error(e);
      toast.error("Error adding action!", {
        autoClose: 3000,
      });
      setIsSubmitLoading(false);
      return;
    }
    setCurrentAction(action.mcaAction);
    setPopUpKey((prevState) => prevState + 1);
    setSubmitted(true);
    setDataLoadNeeded(true);
    setIsSubmitLoading(false);
    modalRef.current?.showModal();
  };

  const [mcActionErrors, setMcActionErrors] = useState({});
  return (
    <>
      <Modal ref={modalRef} closeButton={true}>
        {modalContentRef.current}
      </Modal>
      <div className="ui segment">
        {isLoading || isFetchLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <CiPlay1 />
              <h3 style={{ margin: 0 }}>Actions</h3>
            </div>
            <div className="ui divider"></div>
            <form className="ui form">
              <Dropdown
                error={mcActionErrors.mcaAction}
                resetError={() =>
                  setMcActionErrors((prevState) => {
                    const { mcaAction: _, ...rest } = prevState;
                    return rest;
                  })
                }
                required
                options={actionOptions}
                label="Action"
                value={action.mcaAction}
                onChange={(e, data) => {
                  setAction((prevState) => ({
                    ...prevState,
                    mcaAction: data.value,
                  }));
                }}
              />

              <div
                className={`field ${mcActionErrors.mcaRemark ? "error" : ""}`}
              >
                <label>Remarks</label>
                <TextArea
                  placeholder="Remarks"
                  value={action.mcaRemark}
                  onChange={(e) => {
                    setAction((prevState) => ({
                      ...prevState,
                      mcaRemark: e.target.value,
                    }));
                  }}
                />
                <small style={{ color: "#9f3a38" }}>{`${
                  mcActionErrors.mcaRemark ? mcActionErrors.mcaRemark : ""
                }`}</small>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                  gap: "5px",
                }}
              >
                <Button
                  template="submit"
                  onClick={submitHandler}
                  isLoading={isSubmitLoading}
                  label="Proceed"
                />
              </div>
              <Grid
                heading="Stakeholder Clusters"
                config={[
                  {
                    headerName: "Action",
                    field: "mcaAction",
                    cellRenderer: AsyncDropdownValueRenderer,
                    cellRendererParams: {
                      dropdownKey: "mission_control_action",
                    },
                  },
                  {
                    headerName: "Job",
                    field: "mcaJob",
                    cellRenderer: AsyncOtherRefDropdownValueRenderer,
                    cellRendererParams: {
                      tableName: "transport.tms_t_job",
                      primaryKey: "job_id",
                      fieldName: "job_code",
                    },
                  },
                  {
                    headerName: "Remark",
                    field: "mcaRemark",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                ]}
                content={actionList}
              />
            </form>
          </>
        )}
      </div>
    </>
  );
};

export default MoreInfoOperation;
